import { useMediaPreview } from "./MediaPreviewProvider";
import style from "./PreviewAvatarMedia.module.scss";
import Spinner from "../Spinner/Spinner";
import { useTabs } from "../Tabs/TabsProvider";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";

const PreviewAvatarMedia: React.FC = () => {
    const { t: tForm } = useTranslation("form");
    const { isLoadingMedia, videoUrl, videoRef, imageUrl, setVideoState } = useMediaPreview();
    const formData = useSelector((state: IRootState) => state.avatarForm);
    const isHvalena = formData.type.split("/")[1] === "hvalena";
    const { activeTab } = useTabs();

    const isAvatarTab = activeTab === "appearance";
    const isSceneTab = activeTab === "scene";

    const handleVideoEnded = () => {
        setVideoState("not active");
    };

    if (isLoadingMedia) {
        return (
            <div className={style.spinnerWrapper}>
                <Spinner size={"medium"} />
            </div>
        );
    }

    return (
        <div className={style.avatarVideoContainer}>
                {isAvatarTab && isHvalena && imageUrl && 
                    <img key={imageUrl} src={imageUrl} alt="avatar demo" loading="lazy" />
                }
                {isAvatarTab && videoUrl && !isHvalena && (
                    <video
                        key={videoUrl}
                        ref={videoRef}
                        playsInline
                        preload="auto"
                        className={style.video}
                        onEnded={handleVideoEnded}
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                )}

                {isSceneTab && imageUrl && (
                    <img key={imageUrl} src={imageUrl} alt="avatar in scene" loading="lazy" />
                )}

                {isAvatarTab && !videoUrl && !isHvalena && (
                    <p key="no-video" className={style.previewUnavailable}>
                        {tForm("preview_unavailable")}
                    </p>
                )}

                {isSceneTab && !imageUrl && (
                    <p key="no-image" className={style.previewUnavailable} >
                         {tForm("preview_unavailable")}
                    </p>
                )}
        </div>
    );
};

export default PreviewAvatarMedia;
